import { apiClient } from './client'

export type FitnessHikeTarget = {
  id: string
  level: number
  name: string
  levelLabelStringId?: string | null
  popularHikeId?: string | null
  popularHikeName?: string | null
  thumbnailUrl?: string | null
  numberOfDays?: number | null
  distanceKm: number
  elevationGainMeters: number
  totalElevationLossMeters?: number | null
  packWeightKg: number
  itinerary?: Array<{
    dayNumber: number
    distanceKm: number
    elevationGainMeters: number
    elevationLossMeters?: number | null
  }>
  updatedAt?: string
}

export type FitnessHikeTargetPayload = {
  level: number
  name?: string
  levelLabelStringId?: string | null
  popularHikeId?: string | null
  distanceKm?: number
  elevationGainMeters?: number
  packWeightKg: number
}

export async function getFitnessHikeTargets() {
  const { data } = await apiClient.get<FitnessHikeTarget[]>('/api/admin/fitness-hike-targets')
  return data
}

export async function updateFitnessHikeTargets(payload: FitnessHikeTargetPayload[]) {
  const { data } = await apiClient.put<FitnessHikeTarget[]>('/api/admin/fitness-hike-targets', payload)
  return data
}
